//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import PartialCuid from '@models/PartialCuid';
import { SelectedItemAction } from '@uia/selected-item/selected-item-actions';
import { SELECTED_ITEM } from '@uia/selected-item/selected-item-constants';
import { ISelectedItemState } from '@uia/selected-item/selected-item-model';

const initialState: ISelectedItemState = {
  selectedItemMetadata: undefined,
  isFetchingItemMetadata: false,
  reloadItemMetadata: undefined,
};

export default function SelectedItemReducer(
  state: ISelectedItemState = initialState,
  action: SelectedItemAction,
): ISelectedItemState {
  switch (action.type) {
    case SELECTED_ITEM.FETCH_ITEM_METADATA:
      return {
        ...state,
        isFetchingItemMetadata: true,
      };
    case SELECTED_ITEM.RELOAD_ITEM_METADATA:
      return {
        ...state,
        reloadItemMetadata: action.cuid,
      };
    case SELECTED_ITEM.RELOADED_ITEM_METADATA:
      return {
        ...state,
        reloadItemMetadata: undefined,
      };
    case SELECTED_ITEM.RECEIVE_ITEM_METADATA:
      return {
        ...state,
        isFetchingItemMetadata: false,
        selectedItemMetadata: action.metadata,
      };
    default:
      return state;
  }
}
